import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAccounts } from "../lib/account";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";
import { Clock } from "@phosphor-icons/react";

export default function TimingChart({ direction }) {
  const { activeId } = useAccounts();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!activeId) return;
    const params = new URLSearchParams({ account_id: activeId });
    if (direction && direction !== "all") params.set("direction", direction);
    api.get(`/analytics/timing?${params.toString()}`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [activeId, direction]);

  const rows = (data?.hours || []).map(h => ({
    hour: `${String(h.hour).padStart(2, "0")}h`,
    trades: h.trades,
    pnl: h.pnl,
  }));
  const most = data?.most_active_hour;

  return (
    <div className="rounded-2xl border border-border bg-card p-4 sm:p-6" data-testid="timing-card">
      <div className="flex items-start justify-between mb-3">
        <div className="min-w-0">
          <p className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-muted-foreground flex items-center gap-1">
            <Clock size={12} /> Behaviour
          </p>
          <h3 className="font-display text-base sm:text-lg font-semibold mt-1">Most active trading hours</h3>
          <p className="text-[10px] text-muted-foreground mt-0.5">
            {most !== null && most !== undefined
              ? <>Peak activity around <span className="text-primary font-semibold" data-testid="peak-hour">{String(most).padStart(2, "0")}:00 UTC</span> · {data.total_trades} trades total</>
              : "Not enough trades yet — log a few to see your rhythm."}
          </p>
        </div>
      </div>
      <div className="h-44 sm:h-56" data-testid="timing-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows}>
            <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" />
            <XAxis dataKey="hour" stroke="hsl(var(--muted-foreground))" fontSize={10} interval={2} />
            <YAxis stroke="hsl(var(--muted-foreground))" fontSize={10} />
            <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8 }} />
            <Bar dataKey="trades" radius={[3, 3, 0, 0]}>
              {rows.map((r, i) => (
                <Cell key={i} fill={i === most ? "hsl(var(--primary))" : "hsl(217 91% 40% / 0.5)"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
